export const errorCode = {
    WrongCredentials: 'WrongCredentials',
    Unauthenticated: 'Unauthenticated',
    NotFound: 'NotFound',
    BadRequest: 'BadRequest',
} as const;
